import React, { useEffect, useState } from "react";
import { ClockIcon } from "lucide-react";
const START_SECONDS = 17 * 60 + 34; // 00:17:34

function format(total: number) {
  const h = Math.floor(total / 3600);
  const m = Math.floor(total % 3600 / 60);
  const s = total % 60;
  return {
    h: String(h).padStart(2, "0"),
    m: String(m).padStart(2, "0"),
    s: String(s).padStart(2, "0")
  };
}
export function Countdown({
  compact = false
}: {
  compact?: boolean;
}) {
  const [seconds, setSeconds] = useState(START_SECONDS);
  useEffect(() => {
    const id = setInterval(() => {
      setSeconds(prev => prev <= 1 ? START_SECONDS : prev - 1);
    }, 1000);
    return () => clearInterval(id);
  }, []);
  const {
    h,
    m,
    s
  } = format(seconds);
  const Box = ({
    value,
    label
  }: {
    value: string;
    label: string;
  }) => <div className="flex flex-col items-center" data-id="element-66" data-mp="10c3d5gjo1fzd">
      <div className={`flex items-center justify-center rounded-lg bg-[var(--brand)] font-serif-display font-bold tabular-nums text-white ${compact ? "h-10 w-10 text-lg" : "h-14 w-14 text-2xl sm:h-16 sm:w-16 sm:text-3xl"}`} data-id="element-67" data-mp="10a8xagn94e25">
        {value}
      </div>
      <span className={`mt-1 font-semibold uppercase tracking-wider text-[var(--brand)]/70 ${compact ? "text-[8px]" : "text-[10px]"}`} data-id="element-68" data-mp="t1tqo48vbwe3">
        {label}
      </span>
    </div>;
  return <div className="flex flex-col items-center" data-id="element-69" data-mp="f2atg6hli5gk">
      <div className="mb-2 flex items-center gap-1.5 text-xs font-bold uppercase tracking-wide text-[var(--brand)]" data-id="element-70" data-mp="f33r8hyktkmk">
        <ClockIcon className="h-4 w-4" data-id="element-71" data-mp="a5267rhlbb8g" />
        La oferta especial termina en:
      </div>
      <div className="flex items-center gap-2" data-id="element-72" data-mp="o4k0unhkhipq">
        <Box value={h} label="Horas" data-id="element-73" data-mp="k1ncsh99cuee" />
        <span className="pb-4 font-serif-display text-xl font-bold text-[var(--brand)]" data-id="element-74" data-mp="k0m42jfpsjzu">:</span>
        <Box value={m} label="Min" data-id="element-75" data-mp="1zguka3af82hi" />
        <span className="pb-4 font-serif-display text-xl font-bold text-[var(--brand)]" data-id="element-76" data-mp="1zk0axmyp7cfc">:</span>
        <Box value={s} label="Seg" data-id="element-77" data-mp="1vin87lqwjpcn" />
      </div>
    </div>;
}